import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function BrandStory() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="brand-story"
      data-testid="brand-story-section"
      ref={ref}
      className="py-24 md:py-32 lg:py-40 bg-[#FAF7F3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="flex items-center gap-4 mb-16"
        >
          <div className="w-8 h-[2px] bg-[#c13a05]" />
          <span className="font-sub text-[#c13a05] text-[11px] tracking-[0.25em] font-bold">
            MARKA HİKAYESİ
          </span>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          <div className="md:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <img src="/images/logos/logo-siyah.svg" alt="FINORA" className="h-10 md:h-12 mb-8" />
              <p className="font-body text-[#5A5A58] text-base leading-relaxed font-light mb-5">
                FINORA, Finike'nin binlerce yıllık kültürel hafızasından doğar.
              </p>
              <p className="font-body text-[#5A5A58] text-base leading-relaxed font-light mb-8">
                <strong className="text-[#1A1A1A] font-medium">"FIN"</strong> tamamlanan doğru anı,{" "}
                <strong className="text-[#1A1A1A] font-medium">"ORA"</strong> ise zamanı ve şimdiyi temsil eder.
                Doğru yerde, doğru zamanda kurulan bir yaşamı ifade eder.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="grid grid-cols-2 gap-6"
            >
              {[
                { tr: "Zamansız", en: "TIMELESS", color: "#9ac2cc" },
                { tr: "Kalıcı", en: "ENDURING", color: "#d5bd9a" },
                { tr: "Sessiz Güç", en: "CALM POWER", color: "#7d7441" },
                { tr: "Bilge", en: "WISE", color: "#c13a05" },
              ].map((val, i) => (
                <div key={i} className="border-t-2 pt-4" style={{ borderColor: val.color }}>
                  <p className="font-heading text-lg text-[#1A1A1A]">{val.tr}</p>
                  <p className="font-sub text-[10px] tracking-[0.2em] font-bold mt-1" style={{ color: val.color }}>
                    {val.en}
                  </p>
                </div>
              ))}
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.3 }}
            className="md:col-span-7"
          >
            <div className="img-reveal relative">
              <img src="/images/renders/render3.jpg" alt="FINORA Yaşam Alanı" className="w-full h-[400px] md:h-[550px] object-cover" />
              <div className="absolute bottom-6 right-6 opacity-40">
                <img src="/images/brandmarks/brandmark-beyaz.svg" alt="" className="w-10" />
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-20 md:mt-28 max-w-3xl mx-auto text-center"
        >
          <p className="font-heading text-2xl sm:text-3xl lg:text-4xl text-[#1A1A1A] font-normal leading-snug italic">
            "Acele etmeyen, ama anın değerini bilenler için tasarlanmış bir Akdeniz hayatı."
          </p>
          <div className="flex items-center justify-center gap-3 mt-8">
            <div className="w-3 h-3 rounded-full bg-[#9ac2cc]" />
            <div className="w-3 h-3 rounded-full bg-[#d5bd9a]" />
            <div className="w-3 h-3 rounded-full bg-[#7d7441]" />
            <div className="w-3 h-3 rounded-full bg-[#c13a05]" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
